let csrfToken = null;

export function getCsrfToken() {
  return csrfToken;
}

export function setCsrfToken(token) {
  csrfToken = typeof token === "string" && token.length ? token : null;
  return csrfToken;
}

export function clearCsrfToken() {
  csrfToken = null;
}

export function shouldAttachCsrf(method) {
  const normalized = String(method || "get").toLowerCase();
  return !["get", "head", "options"].includes(normalized);
}
